// Blog index FAQ content. Rendered by AppFAQSection in BlogsPageClient and
// mirrored as FAQPage JSON-LD in page.jsx — edit only this file to change it.
export const blogsFaqs = [
  {
    question: "What does the Keystone blog cover?",
    answer:
      "Practical guides for Shopify merchants on the three areas Keystone builds apps for: customer loyalty and referral programs, product options and customization, and SEO for both Google and AI assistants. Expect how-tos, comparisons of tools and approaches, and strategy pieces grounded in real store setups.",
  },
  {
    question: "How can I follow new Keystone articles?",
    answer:
      "Subscribe to the RSS feed at key-stone.app/feed.xml, or check the archive at key-stone.app/blogs/archive, where every article is listed and grouped by topic.",
  },
  {
    question: "Who writes the Keystone blog?",
    answer:
      "The Keystone team — the people building the Loyalty & Rewards, Product Options & Variants and AI SEO apps for Shopify — so the advice reflects what actually works across the stores using those apps.",
  },
  {
    question: "Can AI assistants read the full articles?",
    answer:
      "Yes. Besides the standard pages, the full text of every published article is available in one machine-readable document at key-stone.app/llms-full.txt, and the site overview lives at key-stone.app/llms.txt.",
  },
];
